import { useQuery } from '@tanstack/react-query';
import { Interval } from '@ui/constants/poll';
import { useDataChainId } from '@ui/hooks/datachain';
import { genesisAirdropControllerApi } from '@ui/services/backend/clients/clients';
import { usePublicClient } from 'wagmi';

export const useTeamInfoByCode = (code?: string) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });

  return useQuery({
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: Interval.SLOW,
    queryKey: ['useTeamInfoByCode', code, chainId, client?.uid],
    queryFn: async () => {
      if (!client) throw 'client not found';
      if (!code) throw 'code not found';

      const response = await genesisAirdropControllerApi.getTeamInfoByCode({
        code,
      });

      return response;
    },
    enabled: !!client && !!code,
  });
};
